export const FETCH_PRIORITIES_REQUEST = 'FETCH_PRIORITIES_REQUEST';
export const FETCH_PRIORITIES_SUCCESS = 'FETCH_PRIORITIES_SUCCESS';
export const FETCH_PRIORITIES_FAILURE = 'FETCH_PRIORITIES_FAILURE';